import React from 'react';
import data from '../assets/Data';

const initialStories = data;

export const useSemiPersistentState = (key, initialState) => {
  const [value, setValue] = React.useState(localStorage.getItem(key) || initialState);

  React.useEffect(() => {
    localStorage.setItem(key, value);
  }, [value, key]);

  return [value, setValue];
};

export const storiesReducer = (state, action) => {
  switch (action.type) {
    case 'SET_STORIES':
      return action.payload;
    case 'REMOVE_STORY':
      return state.filter(story => action.payload.objectID !== story.objectID);
    default:
      throw new Error();
  }
};

export const getAsyncStories = () =>
  new Promise(resolve =>
    setTimeout(() => resolve({ data: { stories: initialStories } }), 500)
  );
